module.exports = __webpack_public_path__ + "static/media/icon-menu-balance.fd058a35.svg";